import React from "react";
import { keySuccessRotationHotpspots } from "../../data/constant"
import $ from "jquery"
const baseUrl = process.env.REACT_APP_S3_BUCKET_BASE_URL;

function getDevice() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) { return "windows"; }
    if (/android/i.test(userAgent)) { return "android"; }
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) { return "ios"; }
    if(isIOS()) {
        return "ios";
    }
    if(isIpadOS()) {
        return "ios";
    }
    return undefined;
}

function isIOS() {
    if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        return true;
    } else {
        return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
    }
}

function isIpadOS() {
    return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
}
const device = getDevice();

// alert(device)

class KeysuccessRotation extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            imageLoaded : false ,
            images : [],
            height : window.innerHeight,
            width : window.innerWidth
        }


        this.frameNumber = 0
        this.rotationlimit = 0
        this.left = false
        this.right = false
        this.imagesarr = null 
        this.rotatestatus = false
        this.prevFramenumber = 0
        this.inter = null
        this.frames = []
        this.start = Date.now();
        this.hotspotToShow  = 2
        this.isSetCanvaseSize = false
    
    }
    

    
    rotateLeft = () => {

        if(!this.rotatestatus){

            $(".key-success-div .hotspots").addClass('hide')

            this.rotatestatus = true
            this.counter = -0.5

            if(this.frameNumber <= 0) {

                this.frameNumber = 100


            }

            if(this.hotspotToShow === 1) {
                this.hotspotToShow = 2
            }else{
                this.hotspotToShow = 1

            }
        }
 
    }


    rotateRight = () => {

        if(!this.rotatestatus){

            $(".key-success-div .hotspots").addClass('hide')

            this.rotatestatus = true
            this.counter = 0.5

            if(this.frameNumber >= 100) {

                this.frameNumber = 0


            }

            
            if(this.hotspotToShow === 1) {
                this.hotspotToShow = 2
            }else{
                this.hotspotToShow = 1

            }
        }



    }

    componentWillUnmount() {

        window.removeEventListener('resize', ()=> { this.changeKeyModalsize(); });

    }

    componentDidUpdate() {

        
    }
    
    componentDidMount() {



		window.addEventListener('resize', ()=> { this.changeKeyModalsize(); });

        this.props.changeLoaderStatus(true)
        this.loadImageArr();
        this.animate()
        // let that = this
        // document.querySelectorAll(".hotspotskey").forEach(e => {

        //     e.addEventListener("click", () => {
        //         alert(1)
        //       //  that.props.changeModalPopupDisplayData(item.ref)
        //     })
        // })

    }

    changeKeyModalsize = () => {

        this.setState({ width : window.innerWidth , height : window.innerHeight})

    }

    loadImageArr = () => {



		const imgUrlArr = [];
        let images_array = [];
        
        for(let i = 1 ; i < 100; i++) {

        var num = "000"+ i.toString();
        var str = num.substr(num.length-4,4);
            imgUrlArr.push(`${baseUrl}datas/thermatru/bg/${str}.png`)
        }

		const selMapArr = imgUrlArr.map(imgUrl => this.loadImage(imgUrl));

		Promise.all(selMapArr).then((imgArr) => {

            this.imagesarr = imgArr

            if(this.imagesarr[0]){
            }

		}).catch((e) => { console.log(e); });

    
	}


    loadImage = (url) => {

		return new Promise((resolve, reject) => {
			let img = new Image();
			img.addEventListener('load', e => 
            {
                resolve(img)
            });
			img.addEventListener('error', () => {
				reject(new Error(`Failed to load image's URL: ${url}`));
			});
			img.src = url;
		});

	}

    canvasRenderImage = (img) => {


        //var that = this
        //setTimeout(() => {

            
        var canvas = this.targetElement;
        var context = canvas.getContext('2d');
        context.width = canvas.clientWidth;
        context.height = canvas.clientHeight;

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(img, canvas.width / 2 - img.width / 2,canvas.height / 2 - img.height / 2);
        //context.drawImage(img, 0, 0, canvas.width, canvas.height);

        //}, 10);
    }
    clamp = (number, min, max) => {
        return Math.max(min, Math.min(number, max));
    }

    hotspotVisibility = () => {

        if(this.hotspotToShow === 1) {

            $(".rules").css('left','26.2%')
            $(".rules").next().css('left','20.2%')

            $(".rules").removeClass('hide')
            $(".progress").removeClass('hide')


        }
        if(this.hotspotToShow === 2) {
            $(".rules").css('left','24.2%')
            $(".prizes").css('left','67%')
            $(".rules").next().css('left','18.2%')
            $(".prizes").next().css('left','61.2%')

            $(".rules").removeClass('hide')
            $(".prizes").removeClass('hide')


        }
    }

    updateImage = () => {





        if(this.rotatestatus ){

 
                        


            if(this.rotationlimit > 99 ) {
                this.hotspotVisibility()
                this.rotationlimit = 0
                this.rotatestatus = false
                return;

            }


            this.frameNumber = this.frameNumber + this.counter
            let inde = Math.round(this.frameNumber)



            if(this.imagesarr[inde]){

                this.canvasRenderImage(this.imagesarr[inde]);
                


            }

            this.rotationlimit += 1;

        }




    }


    animate = () => {

        if( !this.isSetCanvaseSize ){


            // var parent = $("#myCanvas").parent().parent().parent()
            // let parentWidth = parent.outerWidth();
            // let parentHeight = parent.outerHeight();
            this.targetElement = document.getElementById('myCanvas');

            //if(parentWidth > 0 && parentHeight > 0 && this.imagesarr) {
            if(this.imagesarr) {

                // this.targetElement.width  = parentWidth
                // this.targetElement.height = parentHeight
                this.isSetCanvaseSize = true
                this.canvasRenderImage(this.imagesarr[0])
                this.props.changeLoaderStatus(false)

   
            }

        }



        window.requestAnimationFrame(this.animate);

        this.updateImage()
    }

    showHotspotLabel = (e) => {
        $(".key-success-div .hotspotLabel").hide();
        $(e.target).next().show();
    }

    hideHotspotLabel = (e) => {
        $(".key-success-div .hotspotLabel").hide();
    }
    

    handleshowHotspotLabel = (e) => {

        ;[...e.changedTouches].forEach(touch => {

            $(".key-success-div .hotspotLabel").hide();
            $(touch.target).next().show();
        });
    }

    handlehideHotspotLabel = (e) => {

        
        ;[...e.changedTouches].forEach(touch => {

            $(".key-success-div .hotspotLabel").hide();

        });
    }
  



    render() {
        let {width , height} = this.state;
        let hotspotwidth = width *0.08
        let hotspotheight = height * 0.05
        let hotspotfont = height * 0.025
        let hotheight = height * 0.04
        let hotwidth = width * 0.02

        return(

            <div  className="slider keysuccess-div" >

                <div className='new-wrapper  ' >

                            <div className="row">
                                
                                <div className="col-12 key-success-div">

                                    {keySuccessRotationHotpspots && keySuccessRotationHotpspots.map(item=>
                                        <>
                                           
                                           {
                                            (device === undefined) ? 

                                            (
                                                <div 
                                                key={item.key} 
                                                className={`hotspots hotspotskey active ${item.title} ${item.title === 'progress' ? 'hide' : ''}`} 
                                                style={{
                                                    top:item.pos.y+'%', 
                                                    left:item.pos.x+'%',
                                                    width:hotwidth, 
                                                    height:hotheight,
                                                }} 
                                                 onClick={()=> { this.props.changeModalPopupDisplayData(item.ref);}}
                                                 onMouseEnter={(e) => this.showHotspotLabel(e)}
                                                 onMouseLeave={(e) => this.hideHotspotLabel(e)}
                                              

                                                ></div>
                                            )

                                            : 
                                            
                                            (

                                                <div 
                                                    key={item.key} 
                                                    className={`hotspots hotspotskey active ${item.title} ${item.title === 'progress' ? 'hide' : ''}`} 
                                                    style={{
                                                        top:item.pos.y+'%', 
                                                        left:item.pos.x+'%',
                                                        width:hotwidth, 
                                                        height:hotheight,
                                                    }} 
                                                    onClick={()=> { this.props.changeModalPopupDisplayData(item.ref);}}
                                                    // onTouchStart={(e) => this.handleshowHotspotLabel(e)}
                                                    // onTouchEnd ={(e) => this.handlehideHotspotLabel(e)}

                                                ></div>
                                            )
                                           }
                                               

                                                   
                                                
                                                <div className="hotspotLabel" style={{
                                                    top:(item.pos.y - 10) +'%', 
                                                    left:(item.pos.x - 6)+'%',
                                                    width:hotspotwidth, 
                                                    height:hotspotheight,
                                                    fontSize : hotspotfont
                                                    
                                                    }} >
                                                            {item.title}
                                                </div>

                                        </>
                    
                                    )}

                                    <div className="rotation-div">
                                        <button type="button" className="btn btn-rotate" onClick={this.rotateLeft}> <i className="fa fa-angle-left"></i> </button>
                                            
                                        <button type="button" className="btn btn-rotate"  onClick={this.rotateRight}><i className="fa fa-angle-right"></i> </button>
                                    </div>
 


                                    <canvas id="myCanvas" width="1024" height="768" ></canvas>


                                </div>

                            </div>


                </div>

            </div>

        )
    }
}


export default KeysuccessRotation